import { randoms } from "lib/utils"
import { eventsystem } from "./eventsystem";

let id = 0;
const generateId = () => randoms.string(12, "a#")

export const log = (message: string | object) => {
  eventsystem.publish({
    type: "log",
    payload: { id: generateId(), message },
  });
};

export const error = (message: string | object) => {
  eventsystem.publish({
    type: "error",
    payload: { id: generateId(), message },
  });
};

export const image = (src: string, alt: string = "") => {
  eventsystem.publish({
    type: "image",
    payload: { id: generateId(), src, alt },
  });
};

export const table = (data: Record<string, any>[] | any) => {
  eventsystem.publish({
    type: "table",
    payload: { id: generateId(), data },
  });
};

export const divider = (label?: string) => {
  eventsystem.publish({
    type: "divider",
    payload: { id: generateId(), label },
  });
};

export const headline = (text: string) => {
  eventsystem.publish({
    type: "headline",
    payload: { id: generateId(), text },
  });
};

export const clear = () => {
  eventsystem.publish({
    type: "clear",
    payload: {}, // Doesn't need an ID
  });
};
